module.exports = __webpack_public_path__ + "static/media/Riviera_Level_11.10595f57.jpg";